import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import PodsDashboard from './PodsDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyPodsDashboard } from './companyPodsApi';

/** Company Shoorah Pods → Dashboard, scoped to this company. */
const CPodsDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyPodsDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shoorah Pods | Shoorah</title>
      </Helmet>
      <PodsDashboard fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CPodsDashboard;
